
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(161|847)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
